// extracted by mini-css-extract-plugin
export default {"allocation":"Allocation_allocation__rE6rC","container":"Allocation_container__-ax6F","leftSide":"Allocation_leftSide__1L7Lf","rightSide":"Allocation_rightSide__w8R2p"};